import React from 'react'
import classnames from 'classnames'

import { useRecentTranscriptionString } from '../../../firebase/hooks/useLiveTranscription'
import useFeatures from '../../../sharedLegacy/hooks/useFeatures'
import { getRole } from '../../../global/blocs/roomInfo'
import { useAreLiveTranscriptionsEnabled } from '../../../Webinar/components/HeadsUpDisplay/hooks/useLiveTranscriptionsOverlay'

import './Transcription.scss'

const Transcriptions = () => {
  const transcription = useRecentTranscriptionString()

  const { HasLiveTranscriptionsEnabled } = useFeatures()

  const role = getRole()
  const areTranscriptionEnabled = useAreLiveTranscriptionsEnabled()

  if (
    !HasLiveTranscriptionsEnabled ||
    !areTranscriptionEnabled ||
    (role !== 'producer' && role !== 'presenter')
  ) {
    return null
  }

  return (
    <div
      className={classnames('live-transcription-container', {
        hidden: !transcription,
      })}
    >
      <span className="transcription">{transcription}</span>
    </div>
  )
}

export { Transcriptions }
